import { Toaster } from 'sonner';
import { Header } from '@/components/landing/Header';
import { Hero } from '@/components/landing/Hero';
import { Gallery } from '@/components/landing/Gallery';
import { Sectors } from '@/components/landing/Sectors';
import { Categories } from '@/components/landing/Categories';
import { Brands } from '@/components/landing/Brands';
import { Services } from '@/components/landing/Services';
import { Reassurance } from '@/components/landing/Reassurance';
import { Clients } from '@/components/landing/Clients';
import { Testimonials } from '@/components/landing/Testimonials';
import { Contact } from '@/components/landing/Contact';
import { Footer } from '@/components/landing/Footer';
import { MobileCTA } from '@/components/landing/MobileCTA';

export default function Landing() {
    return (
        <div className="relative bg-[#0A0A0A] text-white min-h-screen">
            <Header />
            <main>
                <Hero />
                <Gallery />
                <Sectors />
                <Categories />
                <Brands />
                <Services />
                <Reassurance />
                <Clients />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <MobileCTA />
            <Toaster
                position="bottom-center"
                theme="dark"
                richColors
                toastOptions={{
                    className: 'font-[Manrope]',
                }}
            />
        </div>
    );
}
